const messages = {
    bonus: {
        title: "Oversigt over bonuskreditter",
        description:
            "Bonus i euro tildeles deltagende virksomheder baseret på de indsendte salgsdata.",
        lastMonth: "Sidste måned",
        currentMonth: "Nuværende måned",
        totalCurrentYear: "I alt i indeværende år",
        totalLastYear: "I alt sidste år",
    },
    points: {
        title: "Oversigt over pointkreditter",
        period: "Indeværende kalenderår ({year})",
        totalAwarded: "Samlede tildelte point",
        redeemed: "Indløste point",
        totalBalance: "Samlet pointsaldo",
        redemptionRate: "Indløste point som procent af tildelte point",
        averageAwarded: "Gennemsnitligt tildelte point pr. købt dæk",
        standardAwarded: "Nettopoint fra beregnede salgslinjer, inklusive returneringer",
        bsPlusInclBooster: "Point fra salgslinjer med positiv mængde",
        perTire: "Indløste point pr. købt dæk",
    },
    tires: {
        title: "Oversigt over antal dæk",
        description: "Dæk købt af kunderne",
        prevMonth: "Forrige måned",
        totalLastYear: "I alt sidste år",
        purchaseIndirect: "Køb gennem grossist (indirekte)",
        purchaseDirect: "Køb gennem grossist (direkte)",
        totalCurrentYear: "I alt i indeværende år",
        currentMonth: "Nuværende måned",
    },
    participating: {
        title: "Oversigt over deltagende kunder",
        description:
            "Virksomheder, der registrerer sig hos BRIDGESTONE PLUS, kan tildeles af os via deres kundenumre.",
        total: "I alt",
        newThisMonth: "Nye denne måned",
        newThisYear: "Nye i år",
        createdInCurrentMonth: "Oprettet i indeværende måned (af administrator)",
        loginsCurrentYear: "Login i indeværende år (efter accept af vilkår)",
    },
    brand: {
        title: "Mærke",
        description: "Dine køb i detaljer",
        centerTitle: "Efter\nmærke",
    },
    rim: {
        title: "Fælg",
        centerTitle: "Pr. fælg-\nstørrelse",
    },
    tireGoals: {
        title: "Mål for dækopnåelse",
        subtitle: "Tjen point for dine dækkøb.",
        centerTitle: "Efter\nstørrelse",
        tiresRemaining: "Manglende dæk",
        progressionTarget: "Fremgang mod mål:",
        pointsEarnedPurchases: "point optjent\n" + "gennem dine\n" + "køb",
        pointsEarnedBoosters: "point optjent\n" + "gennem\n" + "boosters",
        purchasesDetail: "Dine køb i detaljer",
        cta: "Find ud af mere om dine point",
        pointsTitle: "Dine point",
        pointsSubtitle: "Point optjent på dine Bridgestone-køb",
        achievementsTitle: "Dine resultater",
        achievementsSubtitle: "Dit årlige engagement:",
        achievementsSubtitle2: "dæk",
    },
    score: {
        title: "Score",
        total: "I alt",
        credits: "Kreditter i",
        deductions: "Fradrag i",
        unlockedPoints: "Ulåste point",
        pendingPoints: "Afventende point",
    },
    score_extended: {
        title1: "Pointsaldo",
        title2: "Bonus i euro",
        balance: "Pointsaldo",
        bonus_in_euro: "Bonus i euro",
        date: "Dato",
        added_points: "Point tilføjet i",
        total_bands: "Samlede bånd",
        goal: "Mål",
        tyres_previous_year: "Solgte dæk sidste år",
        tyres_current_year: "Solgte dæk i år",
        target_this_year: "Salgsmål i år",
        bonus_this_year: "Optjent bonus (€)",
        loyal_minimum: "Minimum loyalitetsniveau",
        bonus_multiplier: "Bonusrate-multiplikator",
    },
    lastImport: {
        label: "Seneste import af salgsdata:",
        on: "den",
    },
    wholesalerTable: {
        title: "Deltagende kunder i detaljer",
        description:
            "Nedenfor finder du virksomheder, der har registreret sig på BRIDGESTONE PLUS med dit firmas kundenumre. " +
            "Du kan bruge filtrene til at ændre sortering eller søge efter specifikke kunder.",
        columns: {
            customer_number: "Kundenr.",
            address_company_name: "Virksomhed",
            address_street: "Gade og husnummer",
            address_postal_code: "Postnummer",
            address_city: "By",
            last_registration: "Sidste registrering",
            network: "Netværk",
            profile_group: "Gruppe",
            tires_amount: "Antal dæk",
            point_balance: "Pointsaldo",
            bonus: "Bonus",
            details: "Detaljer",
        },
        searchPlaceholder: "Søg",
    },
    dealerTable: {
        columns: {
            date: "Dato",
            wholesaler_bs_plus: "Grossist BS+",
            customer_number: "Kundenummer",
            article: "Artikel",
            brand: "Mærke",
            product: "Produkt",
            type: "Type",
            inch: "Tommer",
            season: "Sæson",
            amount: "Antal",
            points: "Point",
            activity: "Aktivitet",
            total_points: "Samlede point",
        },
        title: "Forhandleroversigt",
        description: "Oversigt over forhandleraktiviteter",
    },
    business_units: {
        title: "Forretningsenheder",
        centerTitle: "Pr.\nenhed",
    },
    season: {
        title: "Sæson",
        centerTitle: "Efter\nårstid",
    },
};

export default {
    messages,
};
